import { Record, Map } from 'immutable'

export default Record(
  {
    id: null,
    resolvedAt: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    noteId: null,
    highlight: null,

    comments: Map(),

    // activity management
    lastActivityAt: 0,
    lastActivityBy: '',
    activityCount: 0,
  },
  'thread'
)
